module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/heavyTank-tiny.cdf80a26.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/heavyTank-tiny.png
// module id = 2719
// module chunks = 11